import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

require('./assets/bootstrap/css/bootstrap.min.css')

createApp(App).use(router).mount('#app')
